import Vue from 'vue'
import ApiConfig from './api_config'

export default {
    async get() {
        try {
            const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/widget`)
            return result.data.data
        } catch (error) {
            console.error(error)
            throw error
        }
    },
    async getById(id) {
        try {
            const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/widget/${id}`)
            return result.data.data
        } catch (error) {
            console.error(error)
            throw error
        }
    },
    async getByDashboard(id) {
        try {
            const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/widget/dashboard/${id}`)
            return result.data.data
        } catch (error) {
            console.error(error)
            throw error
        }
    },
    async delete(e) {
        try {
            const result = await Vue.prototype.$http.delete(`${ApiConfig.BASE_URL}/widget`, { data: { _id: e._id } })
            return result.data
        } catch (error) {
            console.error(error)
            throw error
        }
    },
    async insert(e) {
        try {
            const result = await Vue.prototype.$http.post(`${ApiConfig.BASE_URL}/widget`, e)
            return result.data
        } catch (error) {
            console.log(error.response)
            throw error.response.data
        }
    },
    async update(e) {
        try {
            const result = await Vue.prototype.$http.put(`${ApiConfig.BASE_URL}/widget`, e)
            return result.data
        } catch (error) {
            console.error(error)
            throw error
        }
    },

    async updateLayout(e) {
        try {
            const result = await Vue.prototype.$http.put(`${ApiConfig.BASE_URL}/widget/layout`, e)
            return result.data
        } catch (error) {
            console.error(error)
            throw error
        }
    },
    async updateManyLayout(e) {
        try {
            const result = await Vue.prototype.$http.put(`${ApiConfig.BASE_URL}/widget/layout/many`, e)
            return result.data
        } catch (error) {
            console.error(error)
            throw error
        }
    },
}
